import { render, staticRenderFns } from "./powerDetail.vue?vue&type=template&id=2e49518f&scoped=true&"
import script from "./powerDetail.vue?vue&type=script&lang=js&"
export * from "./powerDetail.vue?vue&type=script&lang=js&"
import style0 from "./powerDetail.vue?vue&type=style&index=0&id=2e49518f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49518f",
  null
  
)

export default component.exports